import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getUserInfo, updateUserEmail } from '@/entities/User/api/userRepository'
import type { UserInfo } from '@/entities/User/model/types'
import type { SetEmailResponse } from '@/entities/Payment/model/types'

interface UserData extends UserInfo {
  email?: string | null
}

const USER_KEY = 'vpn_user_data'

export const useUserStore = defineStore('user', () => {
  // Загружаем пользователя из localStorage при инициализации
  const savedUser = localStorage.getItem(USER_KEY)
  const user = ref<UserData | null>(savedUser ? JSON.parse(savedUser) : null)
  
  // Email для платежей
  const paymentEmail = ref('')
  
  // Состояние загрузки и ошибок
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  function setUser(newUser: UserInfo) {
    user.value = { ...newUser }
    localStorage.setItem(USER_KEY, JSON.stringify(user.value))
  }

  function setPaymentEmail(email: string) {
    paymentEmail.value = email
    if (user.value) {
      user.value.email = email
      localStorage.setItem(USER_KEY, JSON.stringify(user.value))
    }
  }

  async function updateEmail(email: string): Promise<SetEmailResponse> {
    try {
      isLoading.value = true
      error.value = null
      
      const response = await updateUserEmail(email)
      
      console.log('Update email API response:', response.data)
      if (user.value) {
        user.value.email = email
        localStorage.setItem(USER_KEY, JSON.stringify(user.value))
      }
      
      return response.data
    } catch (err: any) {
      error.value = err instanceof Error ? err.message : 'Ошибка при обновлении email'
      console.error('Ошибка при обновлении email:', err)
      throw err
    } finally {
      isLoading.value = false
    }
  }

  function clearUser() {
    user.value = null
    paymentEmail.value = ''
    error.value = null
    localStorage.removeItem(USER_KEY)
  }

  function isAuthenticated() {
    return !!user.value
  }

  async function fetchUserInfo() {
    try {
      isLoading.value = true
      error.value = null
      
      const response = await getUserInfo()
      
      console.log('User API response:', response.data)
      setUser(response.data)
      
    } catch (err: any) {
      error.value = err instanceof Error ? err.message : 'Неизвестная ошибка'
      console.error('Ошибка при получении данных пользователя:', err)
    } finally {
      isLoading.value = false
    }
  }

  return {
    user,
    paymentEmail,
    isLoading,
    error,
    setUser,
    setPaymentEmail,
    updateEmail,
    clearUser,
    isAuthenticated,
    fetchUserInfo,
  }
})

